import { gql } from "@apollo/client";

export const SALES_INFO = gql`
  query financialReportTestQuery($where: reports_financial_bool_exp) {
    reports_financial(where: $where) {
  vendor_name
    vendor_id
    transaction_date
    total_transaction_count
    total_tips
    total_tax
    total_refunds
    total_gross_sales
    total_discounts
    total_digital_surcharge
    token_transaction_count
    rfid_transaction_count
    promo_balance_transaction_count
    organization_name
    organization_id
    net_promo_balance_sales
    menu_name
    menu_id
    location_name
    location_id
    gross_token_sales
    gross_rfid_tips
    gross_rfid_sales
    gross_promo_balance_tips
    gross_promo_balance_sales
    gross_credit_tips
    gross_credit_sales
    gross_cash_sales
    gross_cash_balance_tips
    gross_cash_balance_sales
    event_name
    event_id
    credit_transaction_count
    cash_transaction_count
    cash_balance_transaction_count
    net_refunds
    net_promo_balance_sales
    }
  }
`;
